import { render, staticRenderFns } from "./ChatInputField.vue?vue&type=template&id=1d703753&scoped=true&"
import script from "./ChatInputField.vue?vue&type=script&lang=js&"
export * from "./ChatInputField.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputField.vue?vue&type=style&index=0&id=1d703753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d703753",
  null
  
)

export default component.exports